import getParams from './utils/getParams';

class Socket {
    listeners = {};

    initialize(dispatch) {
        if (this.initialized) {
            console.warn('Socket is already initialized');
            return this;
        }

        const params = getParams();
        this.targetOrigin = params.origin; // Get the origin so we can securely post message to the parent

        this.messageHandler = event => {
            if (event.origin.includes("stripe")) {
                // Ignore events from Stripe, we don't want to track those
                return;
            }
            try {
                console.log("[QA - Gift] Received message from parent:", event);
                const { event: eventName, data } = JSON.parse(event.data);

                // These messages have a very similar signature as Redux Actions.
                // Let's dispatch every message to the store, so our app can use the data.
                dispatch({ type: eventName, data });

                // Notify listeners
                if (this.listeners[eventName]) {
                    this.listeners[eventName](data);
                }
            } catch (e) {
                console.log('Error parsing message from parent', e);
            }
        };

        window.addEventListener('message', this.messageHandler);
        this.initialized = true;
        return this;
    }

    postMessageRaw(message, targetWindow = window.parent) {
        targetWindow.postMessage(message, this.targetOrigin);
    }

    postMessage(event, data, targetWindow = window.parent) {
        this.postMessageRaw(JSON.stringify({ event, data }), targetWindow);
    }

    on(event, listener) {
        this.listeners[event] = listener;
    }

    off(event) {
        delete this.listeners[event];
    }

    destroy() {
        if (this.initialized) {
            window.removeEventListener('message', this.messageHandler);
            this.initialized = false;
        }
    }
}

export default new Socket();
